import { render } from "./TableMessagesGroups.vue?vue&type=template&id=b0a10830&scoped=true"
import script from "./TableMessagesGroups.vue?vue&type=script&lang=js"
export * from "./TableMessagesGroups.vue?vue&type=script&lang=js"

import "./TableMessagesGroups.vue?vue&type=style&index=0&id=b0a10830&scoped=true&lang=css"

import exportComponent from "D:\\EME_MARKETING_AND_CONSULTING\\_Proyectos\\bookapps\\Apps Code\\web-admin-bookapps-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0a10830"]])

export default __exports__